import React from 'react';
import logoImg from '../../../assets/Home-page-assets/logo.png';
import footerBg from '../../../assets/Home-page-assets/footer-bg.png';

import phoneIcon from '../../../assets/Home-page-assets/phone.png';
import mailIcon from '../../../assets/Home-page-assets/email.png';
import Bluebackground from '../../../assets/Home-page-assets/blue_background.png';
import Twittericon from '../../../assets/Home-page-assets/twitter-new.png';
import Facebookicon from '../../../assets/Home-page-assets/facebook.png';
import Instagramicon from '../../../assets/Home-page-assets/instagram.png';
import Linkedinicon from '../../../assets/Home-page-assets/linkdin.png';

// Helper Components
const FooterLink = ({ href, children }) => (
  <li>
    <a
      href={href}
      className="text-lg font-dmsans text-white hover:text-white transition-colors duration-200 leading-[40px]"
    >
      {children}
    </a>
  </li>
);

const ContactInfoItem = ({ iconSrc, text }) => (
  <p className="flex items-start mb-4 text-lg font-dmsans text-[#B5B5B5]">
    <img src={iconSrc} alt="" className="w-5 h-5 flex-shrink-0 mr-3 mt-0.5" />
    <span className="text-[#B5B5B5]">{text}</span>
  </p>
);

const SimpleContactText = ({ text }) => (
  <p className="text-lg font-dmsans text-white mb-4">{text}</p>
);

const FooterTitle = ({ children }) => (
  <div className="w-fit mb-10">
    <h3
      className="text-xl font-bold font-dmsans"
      style={{
        color: '#22DAE5',
        background:
          'linear-gradient(90deg, rgba(34,218,229,1) 0%, rgba(6,4,56,1) 100%)',
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        paddingBottom: '4px',
      }}
    >
      {children}
    </h3>
  </div>
);

const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden flex-shrink-0 w-full mx-auto"
      style={{
        minHeight: '530px',
        backgroundColor: '#060438',
      }}
    >
      {/* SOCIAL MEDIA BAR */}



      <div
  className="
    relative z-20 
    px-4 py-2 sm:px-6 sm:py-4 
    flex flex-col sm:flex-row items-center justify-center 
    gap-3 sm:gap-6 
    text-center
  "
  style={{
    backgroundImage: `url(${Bluebackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
>
  {/* Text */}
  <span
    className="
      text-white font-dmsans font-bold 
      text-lg sm:text-xl md:text-2xl lg:text-[25px]
      leading-tight
    "
  >
    Get Connect with us
  </span>

  {/* Social Icons */}
  <div className="flex gap-3 sm:gap-4 items-center flex-wrap justify-center">
    <a href="https://www.linkedin.com/company/api-galaxy/" aria-label="LinkedIn" className="shrink-0">
      <img src={Linkedinicon} alt="LinkedIn" className="w-9 h-9 sm:w-11 sm:h-11 md:w-[50px] md:h-[50px]" />
    </a>
    <a href="https://www.facebook.com/profile.php?id=61574168064772" aria-label="Facebook" className="shrink-0">
      <img src={Facebookicon} alt="Facebook" className="w-9 h-9 sm:w-11 sm:h-11 md:w-[50px] md:h-[50px]" />
    </a>
    <a href="https://x.com/GalaxyApi" aria-label="Twitter" className="shrink-0">
      <img src={Twittericon} alt="Twitter" className="w-9 h-9 sm:w-11 sm:h-11 md:w-[50px] md:h-[50px]" />
    </a>
    <a href="https://www.instagram.com/apigalaxy/" aria-label="Instagram" className="shrink-0">
      <img src={Instagramicon} alt="Instagram" className="w-9 h-9 sm:w-11 sm:h-11 md:w-[50px] md:h-[50px]" />
    </a>
  </div>
</div>



      {/* <div
        className="relative z-20 px-6 sm:px-10 py-3 flex justify-center items-center gap-6 text-base"
        style={{
          backgroundImage: `url(${Bluebackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <span
          className="text-[#FFF] font-dmsans text-center"
          style={{
            fontSize: '25px',
            fontStyle: 'normal',
            fontWeight: 700,
          }}
        >
          Get Connect with us
        </span>
        <div className="flex gap-4 items-center">
          <a href="#" aria-label="LinkedIn">
            <img src={Linkedinicon} alt="LinkedIn" className="w-[50px] h-[50px]" />
          </a>
          <a href="#" aria-label="Facebook">
            <img src={Facebookicon} alt="Facebook" className="w-[50px] h-[50px]" />
          </a>
          <a href="#" aria-label="Twitter">
            <img src={Twittericon} alt="Twitter" className="w-[50px] h-[50px]" />
          </a>
          <a href="#" aria-label="Instagram">
            <img src={Instagramicon} alt="Instagram" className="w-[50px] h-[50px]" />
          </a>
        </div>
      </div> */}

      {/* Background Image */}
      <div
        className="absolute inset-0 z-0 opacity-100"
        style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col lg:flex-row justify-between items-start mt-16 gap-8">
          {/* Logo & Description */}
          <div className="flex flex-col items-start lg:w-1/4">
            <img
              src={logoImg}
              alt="API Galaxy Logo"
              className="mb-4"
              style={{
                width: '170.179px',
                height: '64px',
                flexShrink: 0,
                aspectRatio: '81.179/64',
              }}
            />
            <p className="mb-6 max-w-sm text-[#B5B5B5] font-dmsans text-[18px] font-normal leading-[26px]">
              API Galaxy delivers secure, scalable, and high-performance APIs for
              NBFCs and fintechs, enabling seamless KYC, recharge, travel, and BBPS
              integrations that simplify operations and accelerate growth.
            </p>
            {/* <ContactInfoItem iconSrc={phoneIcon} text="+91-8600555760" />
            <ContactInfoItem iconSrc={mailIcon} text="support@apigalaxy.com" /> */}
          </div>

          {/* Company Links */}
          <div className="flex flex-col lg:w-1/4">
            <FooterTitle>Company</FooterTitle>
            <ul className="space-y-1">
              <FooterLink href="/about">About Us</FooterLink>
              <FooterLink href="/services">Our Services</FooterLink>
              <FooterLink href="https://sandbox.apigalaxy.in/">API Documentation</FooterLink>
              <FooterLink href="/Contact">Contact Us</FooterLink>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col lg:w-1/4">
            <FooterTitle>Quick Links</FooterTitle>
            <ul className="space-y-1">
              <FooterLink href="/PrivacyPolicy">Privacy Policy</FooterLink>
              <FooterLink href="/TermsAndConditions">Terms & Conditions</FooterLink>
              <FooterLink href="https://hexolt.com/jobs/">Careers</FooterLink>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col lg:w-1/4">
            <FooterTitle>Contact</FooterTitle>
            <SimpleContactText text="support@apigalaxy.com" />
            <SimpleContactText text="+91-8600555760" />
            <SimpleContactText text="Nagpur, Maharashtra" />
          </div>
        </div>

        {/* Three Separator Lines */}
      
        <hr className="my-8 border-t border-[#B5B5B5]/10 w-full" />

        {/* Copyright */}
        <div
          className="text-center font-dmsans mb-6"
          style={{
            width: '100%',
            color: '#B5B5B5',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
            borderTop: '1px solid #595656',
            paddingTop: '20px',
            margin: '10px auto',
          }}
        >
          Copyright © 2025 Hexolt Life Solution Private Limited. All Rights
          Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
